const items = [
  "Andrew Meets the Machines",
  "A 13-Part Mini-Series",
  "Transmission from The Bay",
  "Somewhat Humorous",
  "100% Accurate",
  "Mini-Series Releasing Soon",
  "Join the Machines",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden border-y border-crimson/30 bg-black py-4"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {row.map((text, i) => (
          <span
            key={`${text}-${i < items.length ? "a" : "b"}-${i % items.length}`}
            className="mx-6 flex items-center gap-6 font-display text-sm font-bold uppercase tracking-[0.25em] text-[#EAEAEA]/70"
          >
            {text}
            <span className="text-crimson">///</span>
          </span>
        ))}
      </div>
    </div>
  );
}
